module.exports = __webpack_public_path__ + "static/media/suit-clubs.f1c6f926.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/suit-clubs.png
// module id = 133
// module chunks = 0